// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2SkJ1","messages":"Chat_messages__WW1xT","dateDivider":"Chat_dateDivider__2F727"};